import { Winners } from 'constants/common';
import { createAction } from 'typesafe-actions';
import { ACTIONS } from './types';

export const saveWinnerToStoreAction = createAction(ACTIONS.SAVE_WINNER_TO_STORE)<{
  winner: Winners | null;
}>();
